import eppoFlags from './eppoFlags.json';

export default eppoFlags;
